/* Nalvani — interacciones y animaciones (vanilla, sin librerías) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveal al hacer scroll (un solo observer) ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.nv-reveal, .nv-palabras, .nv-img-reveal, [data-nv-observa]');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('nv-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('nv-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -6% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Titulares que entran palabra a palabra ---------- */
  function initPalabras() {
    document.querySelectorAll('[data-nv-palabras]').forEach(function (el) {
      if (el.dataset.nvListo) return;
      el.dataset.nvListo = '1';
      var i = 0;
      function envolver(nodo) {
        Array.prototype.slice.call(nodo.childNodes).forEach(function (n) {
          if (n.nodeType === 3) {
            var frag = document.createDocumentFragment();
            n.textContent.split(/(\s+)/).forEach(function (p) {
              if (!p) return;
              if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
              var w = document.createElement('span'); w.className = 'nv-w';
              var s = document.createElement('span'); s.textContent = p; s.style.setProperty('--nv-i', i++);
              w.appendChild(s); frag.appendChild(w);
            });
            n.parentNode.replaceChild(frag, n);
          } else if (n.nodeType === 1 && n.tagName !== 'BR') { envolver(n); }
        });
      }
      envolver(el);
      el.classList.add('nv-palabras');
    });
  }

  /* ---------- Hero: parallax suave con el cursor y con el scroll ---------- */
  function initHero() {
    var hero = document.querySelector('[data-nv-hero]');
    if (!hero || reduce) return;
    var capa = hero.querySelector('.nv-hero__media-in');
    if (!capa) return;
    var fuerza = parseFloat(hero.dataset.parallax || '1');
    var mx = 0, my = 0, sy = 0, pend = false;
    function pinta() {
      pend = false;
      capa.style.transform = 'translate3d(' + (mx * -14 * fuerza) + 'px,' + (my * -10 * fuerza + sy) + 'px,0)';
    }
    function pide() { if (!pend) { pend = true; requestAnimationFrame(pinta); } }
    hero.addEventListener('pointermove', function (e) {
      var r = hero.getBoundingClientRect();
      mx = (e.clientX - r.left) / r.width - 0.5;
      my = (e.clientY - r.top) / r.height - 0.5;
      pide();
    });
    hero.addEventListener('pointerleave', function () { mx = 0; my = 0; pide(); });
    window.addEventListener('scroll', function () {
      if (window.innerWidth < 750) { if (sy) { sy = 0; pide(); } return; }
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0) return;
      sy = Math.max(0, -r.top) * 0.18 * fuerza;
      pide();
    }, { passive: true });
  }

  /* ---------- Escena sticky del mecanismo ---------- */
  function initMecanismo() {
    document.querySelectorAll('[data-nv-meca]').forEach(function (sec) {
      var pasos = sec.querySelectorAll('.nv-meca__paso');
      var imgs = sec.querySelectorAll('.nv-meca__visual img');
      var num = sec.querySelector('[data-nv-meca-num]');
      var barra = sec.querySelector('.nv-meca__barra span');
      if (!pasos.length) return;
      function activa(idx) {
        pasos.forEach(function (p, i) { p.classList.toggle('nv-activo', i === idx); });
        imgs.forEach(function (im, i) { im.classList.toggle('nv-activo', i === idx); });
        if (num) num.textContent = String(idx + 1).padStart(2, '0');
        if (barra) barra.style.transform = 'scaleX(' + ((idx + 1) / pasos.length) + ')';
      }
      activa(0);
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activa(Array.prototype.indexOf.call(pasos, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      pasos.forEach(function (p) { io.observe(p); });
    });
  }

  /* ---------- Acordeones ---------- */
  function initAcordeones() {
    document.querySelectorAll('[data-nv-acc]').forEach(function (grupo) {
      var unico = grupo.dataset.nvAcc === 'unico';
      grupo.querySelectorAll('.nv-acc__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.nv-acc');
          var abrir = !item.classList.contains('nv-abierto');
          if (unico) grupo.querySelectorAll('.nv-acc.nv-abierto').forEach(function (o) { o.classList.remove('nv-abierto'); o.querySelector('.nv-acc__btn').setAttribute('aria-expanded', 'false'); });
          item.classList.toggle('nv-abierto', abrir);
          btn.setAttribute('aria-expanded', abrir ? 'true' : 'false');
        });
      });
    });
  }

  /* ---------- Selector de colores (portada) ---------- */
  function initColores() {
    document.querySelectorAll('[data-nv-colores]').forEach(function (sec) {
      var sws = sec.querySelectorAll('.nv-swatch');
      var imgs = sec.querySelectorAll('.nv-colores__escena img');
      var nombre = sec.querySelector('[data-nv-color-nombre]');
      var desc = sec.querySelector('[data-nv-color-desc]');
      var halo = sec.querySelector('.nv-colores__halo');
      var link = sec.querySelector('[data-nv-color-link]');
      var auto = parseInt(sec.dataset.auto || '0', 10);
      var actual = 0, timer = null;
      function elige(i) {
        actual = i;
        var sw = sws[i];
        sws.forEach(function (s, k) { s.classList.toggle('nv-activo', k === i); s.setAttribute('aria-pressed', k === i ? 'true' : 'false'); });
        imgs.forEach(function (im, k) { im.classList.toggle('nv-activo', k === i); });
        if (nombre) nombre.innerHTML = '<span>' + sw.dataset.nombre + '</span>';
        if (desc) desc.textContent = sw.dataset.desc || '';
        if (halo) halo.style.backgroundColor = sw.dataset.color;
        if (sec.dataset.tinte === 'true') {
          var wrap = sec.closest('.shopify-section') || sec;
          wrap.style.transition = 'background-color 1s cubic-bezier(0.22, 1, 0.36, 1)';
          wrap.style.backgroundColor = sw.dataset.tinte || '';
          sec.style.backgroundColor = sw.dataset.tinte || '';
        }
        if (link && sw.dataset.url) link.setAttribute('href', sw.dataset.url);
      }
      function reinicia() {
        if (timer) clearInterval(timer);
        if (auto > 0 && !reduce) timer = setInterval(function () { elige((actual + 1) % sws.length); }, auto * 1000);
      }
      sws.forEach(function (s, i) { s.addEventListener('click', function () { elige(i); reinicia(); }); });
      if (sws.length) { elige(0); reinicia(); }
    });
  }

  /* ---------- Página de producto ---------- */
  function formatoDinero(cents) {
    var fmt = window.nvMoneyFormat || '${{amount}}';
    function conSep(n, dec, miles, decs) {
      n = (n / 100).toFixed(dec);
      var p = n.split('.');
      return p[0].replace(/\B(?=(\d{3})+(?!\d))/g, miles) + (p[1] ? decs + p[1] : '');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return conSep(cents, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return conSep(cents, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return conSep(cents, 0, '.', ',');
      return conSep(cents, 2, ',', '.');
    });
  }

  function initProducto() {
    var sec = document.querySelector('[data-nv-producto]');
    if (!sec) return;
    var principal = sec.querySelectorAll('.nv-prod__principal img');
    var minis = sec.querySelectorAll('.nv-prod__mini');
    var actual = Math.max(0, Array.prototype.findIndex.call(principal, function (im) { return im.classList.contains('nv-activo'); }));
    function verMedia(i) {
      if (!principal.length) return;
      actual = (i + principal.length) % principal.length;
      principal.forEach(function (im, k) { im.classList.toggle('nv-activo', k === actual); });
      minis.forEach(function (m, k) { m.classList.toggle('nv-activo', k === actual); });
      var m = minis[actual];
      if (m && m.parentNode.scrollTo) m.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    }
    minis.forEach(function (m, i) { m.addEventListener('click', function () { verMedia(i); }); });
    var prev = sec.querySelector('[data-nv-prev]'), next = sec.querySelector('[data-nv-next]');
    if (prev) prev.addEventListener('click', function () { verMedia(actual - 1); });
    if (next) next.addEventListener('click', function () { verMedia(actual + 1); });
    // deslizar en móvil
    var cont = sec.querySelector('.nv-prod__principal'), x0 = null;
    if (cont) {
      cont.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      cont.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0; x0 = null;
        if (Math.abs(dx) > 40) verMedia(actual + (dx < 0 ? 1 : -1));
      });
    }

    // cantidad
    var qty = sec.querySelector('.nv-prod__cantidad input');
    sec.querySelectorAll('[data-nv-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.nvQty, 10));
        qty.value = v;
      });
    });

    // variantes
    var dataEl = sec.querySelector('[data-nv-variantes]');
    var input = sec.querySelector('input[name="id"]');
    var btn = sec.querySelector('[data-nv-anadir]');
    var precio = sec.querySelectorAll('[data-nv-precio]');
    var antes = sec.querySelector('[data-nv-antes]');
    var estado = sec.querySelector('[data-nv-estado]');
    var barraBtn = document.querySelector('[data-nv-barra-btn]');
    var barraPrecio = document.querySelector('[data-nv-barra-precio]');
    var barraImg = document.querySelector('[data-nv-barra-img]');
    if (dataEl) {
      var variantes = JSON.parse(dataEl.textContent);
      var grupos = sec.querySelectorAll('[data-nv-opcion]');
      function seleccion() {
        return Array.prototype.map.call(grupos, function (g) {
          var a = g.querySelector('.nv-prod__pill.nv-activo');
          return a ? a.dataset.valor : null;
        });
      }
      function aplica() {
        var sel = seleccion();
        var v = variantes.find(function (vv) { return vv.options.every(function (o, i) { return o === sel[i]; }); });
        grupos.forEach(function (g) {
          var lbl = g.querySelector('[data-nv-opcion-valor]');
          var a = g.querySelector('.nv-prod__pill.nv-activo');
          if (lbl && a) lbl.textContent = a.dataset.etiqueta || a.dataset.valor;
        });
        if (!v) { btn.disabled = true; btn.querySelector('span').textContent = btn.dataset.noDisp; return; }
        input.value = v.id;
        precio.forEach(function (p) { p.textContent = formatoDinero(v.price); });
        if (barraPrecio) barraPrecio.textContent = formatoDinero(v.price);
        if (antes) {
          if (v.compare_at_price && v.compare_at_price > v.price) { antes.textContent = formatoDinero(v.compare_at_price); antes.hidden = false; }
          else antes.hidden = true;
        }
        btn.disabled = !v.available;
        btn.querySelector('span').textContent = v.available ? btn.dataset.disp : btn.dataset.agot;
        if (barraBtn) barraBtn.disabled = !v.available;
        if (estado) {
          estado.classList.toggle('nv-sin', !v.available);
          estado.querySelector('span').textContent = v.available ? estado.dataset.disp : estado.dataset.agot;
        }
        if (v.media_pos != null) {
          verMedia(v.media_pos);
          var im = principal[v.media_pos];
          if (barraImg && im) barraImg.src = im.currentSrc || im.src;
        }
        if (window.history && window.history.replaceState) {
          var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', u.toString());
        }
      }
      grupos.forEach(function (g) {
        g.querySelectorAll('.nv-prod__pill').forEach(function (p) {
          p.addEventListener('click', function () {
            g.querySelectorAll('.nv-prod__pill').forEach(function (o) { o.classList.remove('nv-activo'); o.setAttribute('aria-pressed', 'false'); });
            p.classList.add('nv-activo'); p.setAttribute('aria-pressed', 'true');
            aplica();
          });
        });
      });
    }

    // barra de compra flotante
    var barra = document.querySelector('[data-nv-barra]');
    if (barra && btn) {
      var pendiente = false;
      function revisaBarra() {
        pendiente = false;
        barra.classList.toggle('nv-visible', btn.getBoundingClientRect().bottom < 0);
      }
      window.addEventListener('scroll', function () {
        if (!pendiente) { pendiente = true; requestAnimationFrame(revisaBarra); }
      }, { passive: true });
      revisaBarra();
      if (barraBtn) barraBtn.addEventListener('click', function () { btn.click(); });
    }
  }

  function init() {
    initPalabras();
    initReveal();
    initHero();
    initMecanismo();
    initAcordeones();
    initColores();
    initProducto();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // editor de Shopify: re-inicializar al cargar/mover secciones
  document.addEventListener('shopify:section:load', init);
})();
